import ExperienceItem from "./ExperienceItem";

function ExperienceList({expList}) {
  return (
    <ul>
      {
        expList.map((item, index) => (
          <ExperienceItem eachExp={ item } index={ index }  key={ index }/>
        ))
      }
    </ul>
  );
}

export default ExperienceList;